import React, { useState, useEffect } from 'react';
import api from '../services/api';
import IconButton from './IconButton';
import { Button } from './ui';

export default function TimeLogSection({ taskId }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ duration_hours: '', description: '', start_time: '', end_time: '' });
  const [error, setError] = useState(null);

  const loadLogs = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/tasks/${taskId}/time-logs`);
      setLogs(data);
    } catch (err) {
      console.error('Failed to load time logs', err);
      setError('Failed to load time logs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLogs();
  }, [taskId]);

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...form };
      await api.post(`/tasks/${taskId}/time-logs`, payload);
      setForm({ duration_hours: '', description: '', start_time: '', end_time: '' });
      setShowForm(false);
      await loadLogs();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add time log');
    }
  };

  const handleDelete = async (logId) => {
    if (!window.confirm('Delete this time log?')) return;
    try {
      await api.delete(`/tasks/${taskId}/time-logs/${logId}`);
      setLogs(prev => prev.filter(l => l.id !== parseInt(logId, 10)));
    } catch (err) {
      setError('Failed to delete time log');
    }
  };

  if (loading) return <div>Loading time logs...</div>;

  return (
    <div style={{ marginTop: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3>Time Logs</h3>
        <Button onClick={() => setShowForm(s => !s)}>{showForm ? 'Cancel' : 'Add Time Log'}</Button>
      </div>

      {showForm && (
        <form onSubmit={handleAdd} style={{ marginTop: 12, marginBottom: 12 }}>
          <div style={{ display: 'flex', gap: 12 }}>
            <input
              type="number"
              min="0"
              step="0.25"
              placeholder="Duration (hours)"
              value={form.duration_hours}
              onChange={e => setForm({ ...form, duration_hours: e.target.value })}
              required
              style={{ padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}
            />
            <input
              type="datetime-local"
              value={form.start_time}
              onChange={e => setForm({ ...form, start_time: e.target.value })}
              style={{ padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}
            />
            <input
              type="datetime-local"
              value={form.end_time}
              onChange={e => setForm({ ...form, end_time: e.target.value })}
              style={{ padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}
            />
          </div>
          <div style={{ marginTop: 8 }}>
            <textarea
              placeholder="Notes / description"
              value={form.description}
              onChange={e => setForm({ ...form, description: e.target.value })}
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            />
          </div>
          {error && <div style={{ color: '#de350b', marginTop: 8 }}>{error}</div>}
          <div style={{ marginTop: 8 }}>
            <Button type="submit">Save</Button>
          </div>
        </form>
      )}

      <div style={{ marginTop: 12 }}>
        {logs.length === 0 ? (
          <div>No time logs yet.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {logs.map(log => (
              <div key={log.id} style={{ padding: 12, borderRadius: 6, background: '#f8f9fa', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 600 }}>{(log.duration_minutes / 60).toFixed(2)} hrs</div>
                  <div style={{ color: '#42526e' }}>{log.description || '-'}</div>
                  <div style={{ fontSize: 12, color: '#6b778c' }}>
                    {log.logged_by ? `${log.logged_by.firstName || ''} ${log.logged_by.lastName || ''} (${log.logged_by.email})` : '-'} • {new Date(log.created_at).toLocaleString()}
                  </div>
                </div>
                <div>
                  <IconButton title="Delete log" onClick={() => handleDelete(log.id)}>
                    <svg viewBox="0 0 24 24" fill="none"><path d="M3 6h18" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 6v12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </IconButton>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}